import isEmpty from 'lodash/isEmpty';
import { replace } from 'redux-first-router';

import { querySel } from '@location';
import { emptyObj } from '@shared';
import { setOrganization } from '@shared/duck/actions';
import { organizationPositionsSel } from '@shared/duck/selectors/general.selectors';
import { newPermissions } from '@shared/newPermissions';

import {
  OwnActivityLogsPage,
  ProfilePage,
  ProfilePagePlaceholder,
} from './components';
import { ROUTE_OWN_ACTIVITY_LOGS, ROUTE_PROFILE } from './duck';

const routes = {
  [ROUTE_PROFILE]: {
    path: '/profile',
    Component: ProfilePage,
    Placeholder: ProfilePagePlaceholder,
    titleId: 'page.profile',
    permission: newPermissions.VIEW_PROFILE_PAGE,
    thunk: (dispatch, getState) => {
      const state = getState();
      const positions = organizationPositionsSel(state);
      const { organizationGuid = '' } = querySel(state) || emptyObj;
      if (!isEmpty(organizationGuid) && !isEmpty(positions)) {
        const foundedPosition = positions.find(
          p => p.organizationGuid === organizationGuid,
        );
        replace('/profile');
        if (foundedPosition) {
          dispatch(
            setOrganization({
              guid: foundedPosition.organizationGuid,
              programType: foundedPosition.programType,
              parentOrgGuid: foundedPosition.organizationGuid,
            }),
          );
        }
      }
    },
  },
  [ROUTE_OWN_ACTIVITY_LOGS]: {
    path: '/profile/activityLogs/:activityType',
    Component: OwnActivityLogsPage,
    Placeholder: ProfilePagePlaceholder,
    titleId: 'page.youthActivityLogs',
    permission: newPermissions.VIEW_PROFILE_PAGE,
  },
};

export default routes;
